import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { ShoppingCart, User, LogOut, Menu, X } from 'lucide-react';

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const { itemCount } = useCart();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  return (
    <header className="network-header">
      <div className="nav-wrapper">
        <Link to="/" className="network-logo">
          Treinamentos Personalizados para Estética, Saúde e Performance
        </Link>

        {/* Desktop Navigation */}
        <nav className="network-nav">
          <Link to="/" className="network-nav-link">Início</Link>
          <Link to="/produtos" className="network-nav-link">Produtos</Link>
          
          {isAuthenticated ? (
            <>
              <Link to="/meus-ebooks" className="network-nav-link">
                <User size={18} style={{ display: 'inline', marginRight: '6px' }} />
                Meus E-books
              </Link>
              <button onClick={handleLogout} className="network-nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                <LogOut size={18} style={{ display: 'inline', marginRight: '6px' }} />
                Sair
              </button>
            </>
          ) : (
            <Link to="/login" className="network-nav-link">
              <User size={18} style={{ display: 'inline', marginRight: '6px' }} />
              Login
            </Link>
          )}
          
          <Link to="/carrinho" className="network-nav-link" style={{ position: 'relative' }}>
            <ShoppingCart size={18} style={{ display: 'inline' }} />
            {itemCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '-8px',
                right: '-8px',
                background: 'var(--brand-primary)',
                color: 'var(--brand-dark)',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: '700'
              }}>
                {itemCount}
              </span>
            )}
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '8px'
          }}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu" style={{
          background: 'var(--brand-dark)',
          padding: '16px',
          borderRadius: '0 0 25px 25px',
          marginTop: '8px'
        }}>
          <Link to="/" className="network-nav-link" style={{ display: 'block', marginBottom: '12px' }} onClick={() => setMobileMenuOpen(false)}>Início</Link>
          <Link to="/produtos" className="network-nav-link" style={{ display: 'block', marginBottom: '12px' }} onClick={() => setMobileMenuOpen(false)}>Produtos</Link>
          
          {isAuthenticated ? (
            <>
              <Link to="/meus-ebooks" className="network-nav-link" style={{ display: 'block', marginBottom: '12px' }} onClick={() => setMobileMenuOpen(false)}>
                Meus E-books
              </Link>
              <button onClick={handleLogout} className="network-nav-link" style={{ display: 'block', marginBottom: '12px', background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left' }}>
                Sair
              </button>
            </>
          ) : (
            <Link to="/login" className="network-nav-link" style={{ display: 'block', marginBottom: '12px' }} onClick={() => setMobileMenuOpen(false)}>
              Login
            </Link>
          )}
          
          <Link to="/carrinho" className="network-nav-link" style={{ display: 'block' }} onClick={() => setMobileMenuOpen(false)}>
            Carrinho ({itemCount})
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;